import { useState, useEffect, useRef, useMemo } from "react";
import { CSSTransition } from 'react-transition-group';
import { createPortal } from "react-dom";

import { BsThreeDotsVertical } from "react-icons/bs";
import { LuGitMerge } from "react-icons/lu";
import { LuWorkflow } from "react-icons/lu"; // has symmetrical flow lines
//import FilterIcon from "../../assets/images/filter.svg";
import { LuInfinity } from "react-icons/lu";



import { useDispatch, useSelector } from "react-redux";
import { openOverlay, deleteRisk, gotoRiskDashboard, gotoBowtie } from "../../store/actions/riskActions";
import { gotoIncident } from "../../store/actions/incidentActions";

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css




/*
const DefaultColumnFilter = ({ name, column: { filterValue, setFilter, preFilteredRows, id } }) => {

    const [filterOpen, setFilterOpen] = useState(false);
    return (
        <div className="">
            {filterOpen ? (

                <>
                    <div className="flex items-center">
                        <img onClick={() => { setFilterOpen(!filterOpen); setFilter('') }} src={FilterIcon} alt="Filter Icon" className="w-4 h-4 mr-1" />
                        <input
                            value={filterValue || ''}
                            onChange={e => {
                                setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
                            }}
                            autoFocus
                            placeholder={`Search ${id}`}
                            style={{
                                width: '100%',
                                padding: '4px',
                                borderRadius: '5px',
                                fontWeight: 'normal'
                            }}
                        />
                    </div>
                </>
            ) : (
                <div className="flex items-center whitespace-nowrap">
                    <span>{name}</span>
                    <img onClick={() => setFilterOpen(!filterOpen)} src={FilterIcon} alt="Filter Icon" className="w-4 h-4 ml-2" />
                </div>
            )}
        </div>
    );
};
*/
/*
const EditableCell = ({ value, row, column }) => {
    return (

        <div>{value}</div>
    )
}

*/
/*
const CustomHeader2= ({ column }) => {

    const hasFilter = column.hasFilter || false;
    return (
        hasFilter ? <DefaultColumnFilter name={column.title} column={column} /> : <div>{column.title}</div>

    );
};
*/
const DropdownMenu = ({ row, onClose }) => {
  const dispatch = useDispatch();
  const { currentPage, pageSize, sortBy } = useSelector((s) => s.risk);
  const { profile } = useSelector((s) => s.profile);

  const submit = () => {
    confirmAlert({
      message: "Are you sure you want to delete this risk?",
      buttons: [
        {
          label: "Yes",
          onClick: () =>
            dispatch(
              deleteRisk(
                row.original.ID,
                currentPage,
                pageSize,
                sortBy,
                row.original.DepartmentID
              )
            )
        },
        { label: "No", onClick: () => void 0 }
      ]
    });
    onClose?.();
  };

  return (
    <div
      className="w-48 bg-white text-sm rounded-md border border-[#3b3b3b] shadow-lg"
      style={{ pointerEvents: "auto" }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="p-2">
        <div
          className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black"
          onClick={() => {
            dispatch(openOverlay(row.original.ID));
            onClose?.();
          }}
        >
          <i className="fas fa-edit text-xs"></i>
          <span className="ml-2">
            {profile.role === "Auditor" ? "View" : "Edit"}
          </span>
        </div>

        <div
          className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black"
          onClick={() => {
            dispatch(gotoRiskDashboard(row.original.ID));
            onClose?.();
          }}
        >
          <i className="fas fa-chart-line text-xs"></i>
          <span className="ml-2">Stats</span>
        </div>

        <div
          className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black"
          onClick={() => {
            dispatch(gotoBowtie(row.original.ID));
            onClose?.();
          }}
        >
          <LuInfinity className="w-4 h-4" />
          <span className="ml-2">Bowtie</span>
        </div>

        <div
          className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black"
          onClick={() => {
            dispatch(gotoIncident(row.original.ID));
            onClose?.();
          }}
        >
          <i className="fas fa-exclamation-triangle text-xs"></i>
          <span className="ml-2">Incident</span>
        </div>

        {profile.role !== "Auditor" && (
          <div
            className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black"
            onClick={submit}
          >
            <i className="fas fa-trash text-xs"></i>
            <span className="ml-2">Delete</span>
          </div>
        )}
      </div>
    </div>
  );
};

const DropdownLabel = ({ row }) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  const getViewportPos = () => {
    const r = buttonRef.current?.getBoundingClientRect();
    if (!r) return { top: 0, left: 0 };
    return { top: r.bottom + 4, left: r.left }; // no gap!
  };
  const [pos, setPos] = useState(getViewportPos());

  const toggle = () => {
    setPos(getViewportPos());
    setIsOpen((v) => !v);
  };

  useEffect(() => {
    if (!isOpen) return;
    const onDown = (e) => {
      const inBtn = buttonRef.current?.contains(e.target);
      const inMenu = menuRef.current?.contains(e.target);
      if (!inBtn && !inMenu) setIsOpen(false);
    };
    document.addEventListener("mousedown", onDown, true);
    return () => document.removeEventListener("mousedown", onDown, true);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const recalc = () => setPos(getViewportPos());
    window.addEventListener("scroll", recalc, true);
    window.addEventListener("resize", recalc);
    return () => {
      window.removeEventListener("scroll", recalc, true);
      window.removeEventListener("resize", recalc);
    };
  }, [isOpen]);

  const portalRoot = useMemo(() => document.body, []);

  return (
    <>
      <div
        ref={buttonRef}
        className="rounded-full cursor-pointer text-[#3b3b3b] dropdown-menu p-2 w-10 h-10 text-center"
        onClick={toggle}
        title="More"
      >
        <i className="fas fa-ellipsis-v"></i>
      </div>

      {isOpen &&
        createPortal(
          <div
            className="fixed z-[999999] pointer-events-none"
            style={{ top: pos.top, left: pos.left }}
          >
            <div ref={menuRef} className="pointer-events-auto">
              <DropdownMenu row={row} onClose={() => setIsOpen(false)} />
            </div>
          </div>,
          portalRoot
        )}
    </>
  );
};





const statusBadge = (value) => {
    // Check if the value is 'Draft' or 'Approved' to set the font color
    const fontColor = (value === 'Draft' || value === 'Approved') ? 'text-customGreen' : 'text-customYellow';

    return (
        <div className={`badge ${fontColor} items-center overflow-hidden text-ellipsis whitespace-nowrap font-bold p-2`}>
            <span>{value}</span>
        </div>
    )
}

/*
const Badge = ({ value, isPositive, arrowType }) => {
    const backgroundColor = isPositive ? 'bg-customGreen' : 'bg-customRed';
    const arrow = arrowType === 'up' ? ArrowUpGreen : arrowType === 'down' ? ArrowDownRed : arrowType === 'left' ? ArrowUpRed : ArrowDownGreen;

    return (
        <div className={`badge ${backgroundColor} flex items-center justify-center text-center p-2 rounded-[5px] text-white whitespace-nowrap overflow-hidden text-ellipsis`}>
            <span className="">{value.replace('+', '').replace('-', '')}</span>
            <img src={arrow} alt="Arrow" className="w-4 h-4 ml-1" />
        </div>
    )
};
*/

const cellRenderer = ({ value }) => {
    return <div className="p-2">{value}</div>
}

const getBarColor = (value) => {
    if (value >= 75) return '#00AFB9'; // Green for high values
    if (value >= 50) return '#FFD166'; // Yellow for medium values
    if (value > 0) return '#EF476F'; // Red for low values
    return '#f07167'; // Default background color for 0
};


const columns = [
    {
        Header: 'ID',
        accessor: 'ID',
        title: 'ID',
        Cell: cellRenderer
    },
    {
        Header: 'Owner',
        accessor: 'Owner',
        title: 'Owner',
        hasFilter: true,
        Cell: ({ value, row }) => {
            const ownerFirstName = row.original.OwnerFirstName; // Access first name from the row data
            const ownerLastName = row.original.OwnerLastName; // Access last name from the row data
            return (
                <div className="overflow-hidden text-ellipsis" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                    {ownerFirstName} {ownerLastName}
                </div>
            );
        }
    },
    {

        Header: 'Title',
        accessor: 'Title',
        title: 'Title',
        // Cell: EditableCell
        Cell: ({ value }) => (
            <div className="overflow-hidden text-ellipsis" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                {value || 'N/D'}
            </div>
        )
    },
    {
        Header: 'Control Efficiency',
        accessor: 'AverageEfficiencyLevel',
        title: 'Control Efficiency',
        hasFilter: true,
        Cell: ({ value }) => (
            <div className="relative w-32 h-6 bg-[#999999] rounded-full flex items-center">
                    <div
        className="absolute h-full rounded-full"
        style={{
            width: `${value || 0}%`,
            backgroundColor: getBarColor(value), // Call a function to determine the color
        }}
    />
                <span className="relative text-white ml-2 text-xs">
                    {value ? `${parseFloat(value).toFixed(0)}%` : 'No Control'}
                </span>
            </div>
        )
    },

   {
  Header: 'Status',
  accessor: 'Status',
  title: 'Status',
  hasFilter: true,
  Cell: ({ value, row }) => (
    <div
      className="flex items-center justify-start px-1"
      onClick={e => e.stopPropagation()}
    >
      {/* keep your perfect left nudge */}
      <div className="-ml-3">
        {statusBadge(value)}
      </div>

      {/* give the dropdown some breathing room */}
      <div className="ml-14">
        <DropdownLabel row={row} />
      </div>
    </div>
  )
},

    {
        accessor: 'financial',
        title: 'financial',
        dontshow: true,
        Cell: ({ value }) => null // Return null to not render anything


    },
    {
        accessor: 'operational',
        title: 'operational',
        dontshow: true,
        Cell: ({ value }) => null // Return null to not render anything

    },
    {
        accessor: 'reputational',
        title: 'reputational',
        dontshow: true,
        Cell: ({ value }) => null // Return null to not render anything

    },
    {
        accessor: 'financial_history',
        title: 'financial_history',
        dontshow: true,
        Cell: ({ value }) => null // Return null to not render anything


    },
    {
        accessor: 'operational_history',
        title: 'operational_history',
        dontshow: true,
        Cell: ({ value }) => null // Return null to not render anything

    },
    {
        accessor: 'reputational_history',
        title: 'reputational_history',
        dontshow: true,
        Cell: ({ value }) => null // Return null to not render anything

    },
];

const complianceColumns = [
    {
        Header: 'ID',
        accessor: 'ID',
        title: 'ID',
        Cell: cellRenderer
    },
    {
        Header: 'Owner',
        accessor: 'Owner',
        title: 'Owner',
        hasFilter: false,
        Cell: ({ value, row }) => {
            const ownerFirstName = row.original.OwnerFirstName; // Access first name from the row data
            const ownerLastName = row.original.OwnerLastName; // Access last name from the row data
            return (
                <div className="overflow-hidden text-ellipsis" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                    {ownerFirstName} {ownerLastName}
                </div>
            );
        }
    },
    {

        Header: 'Title',
        accessor: 'Title',
        title: 'Title',
        // Cell: EditableCell
        Cell: ({ value }) => (
            <div className="overflow-hidden text-ellipsis" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                {value || 'N/D'}
            </div>
        )
    },
    {
        Header: 'Compliance Level',
        accessor: 'ComplianceLevel',
        title: 'Compliance Level',
        hasFilter: true,
        Cell: ({ value }) => (
            <div className="relative w-32 h-6 bg-[#999999] rounded-full flex items-center">
                <div
                    className="absolute h-full rounded-full"
                    style={{
                        width: `${value || 0}%`,
                        backgroundColor: getBarColor(value),
                    }}
                />
                <span className="relative text-white ml-2 text-xs">
                    {value ? `${parseFloat(value).toFixed(0)}%` : 'No Data'}
                </span>
            </div>
        ),
    },

     {
        Header: 'Status',
        accessor: 'Status',
        title: 'Status',
        hasFilter: true,

        Cell: ({ value, row }) => (
            <div className="flex items-center justify-between">
                {/* Render the status badge */}
                {statusBadge(value)}
                {/* Render the More dropdown icon */}
                <DropdownLabel row={row} />
            </div>
        )
    },

    {
        accessor: 'financial',
        title: 'financial',
        dontshow: true,
        Cell: ({ value }) => null // Return null to not render anything


    },
    {
        accessor: 'operational',
        title: 'operational',
        dontshow: true,
        Cell: ({ value }) => null // Return null to not render anything

    },
    {
        accessor: 'reputational',
        title: 'compliance',
        dontshow: true,
        Cell: ({ value }) => null // Return null to not render anything

    },
    {
        accessor: 'financial_history',
        title: 'financial_history',
        dontshow: true,
        Cell: ({ value }) => null // Return null to not render anything


    },
    {
        accessor: 'operational_history',
        title: 'operational_history',
        dontshow: true,
        Cell: ({ value }) => null // Return null to not render anything

    },
    {
        accessor: 'reputational_history',
        title: 'reputational_history',
        dontshow: true,
        Cell: ({ value }) => null // Return null to not render anything

    },
];


export { columns, complianceColumns};
